import { GeneratedSkedApiClient } from "../generated-client";
import type { paths } from "../generated/sked-api-openapi-types";

type CreateInboxOperation = paths["/content-inbox/inbox"]["post"];
type CreateInboxBody = NonNullable<
  CreateInboxOperation["requestBody"]
>["content"]["application/json"];
type CreateInboxResponse =
  CreateInboxOperation["responses"][200]["content"]["application/json"];

const generatedSkedApiClient = new GeneratedSkedApiClient<paths>();

export async function createCollection(
  input: CreateInboxBody
): Promise<CreateInboxResponse> {
  const result = await generatedSkedApiClient.client.POST(
    "/content-inbox/inbox",
    {
      body: input,
    }
  );

  return await generatedSkedApiClient.unwrap(result);
}
